(function () {
  'use strict';

  // ── Apply discount ────────────────────────────────────────────────────
  document.addEventListener('submit', async function (e) {
    if (!e.target.matches('[data-discount-form]')) return;
    e.preventDefault();

    var form = e.target;
    var input = form.querySelector('.icemix-discount__input');
    var errorEl = form.querySelector('.icemix-discount__error');
    if (!input) return; // form is in applied state — no input present

    var code = input.value.trim();
    if (!code) return;

    setLoading(form, true);
    errorEl.hidden = true;

    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
      });

      var cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      var cart = await cartRes.json();

      if (cart.total_discount === 0) {
        errorEl.hidden = false;
        setLoading(form, false);
        return;
      }

      await refreshCartDrawer();
    } catch (_) {
      errorEl.hidden = false;
      setLoading(form, false);
    }
  });

  // ── Remove discount ───────────────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    if (!e.target.closest('[data-discount-remove]')) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ discount: '' }),
      });
    } catch (_) {}

    await refreshCartDrawer();
  });

  // ── Helpers ───────────────────────────────────────────────────────────
  function setLoading(form, isLoading) {
    var input = form.querySelector('.icemix-discount__input');
    var button = form.querySelector('.icemix-discount__apply');
    if (!input || !button) return;
    input.disabled = isLoading;
    button.disabled = isLoading;
    button.textContent = isLoading ? 'Applying...' : 'Apply';
  }

  // Auto-clear discount when cart becomes empty after any item removal.
  // PUB_SUB_EVENTS / subscribe are top-level declarations from constants.js /
  // pubsub.js — they are not on window, so use typeof guards.
  // Fast path: if the event carries item_count > 0, bail immediately.
  // Slow path (item_count === 0): fetch /cart.js for authoritative
  // discount_codes — it's a single cheap call only on the empty-cart case.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async function (event) {
      try {
        if (event && event.cartData && event.cartData.item_count > 0) return;

        var res = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var cart = await res.json();

        if (cart.item_count === 0 && cart.discount_codes && cart.discount_codes.length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' }),
          });
          // No drawer refresh — Dawn's own is-empty rendering handles the empty state
        }
      } catch (_) {
        // Silent fail — stale discount clears on next page load; user can also
        // remove manually from the discount form before checkout
      }
    });
  }

  async function refreshCartDrawer() {
    // On /cart page, do a full reload — there's no drawer UX, and the cart
    // page form is a separate DOM tree from the hidden global drawer
    if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
      window.location.reload();
      return;
    }

    // Capture open state before replacement — outerHTML swap resets all classes
    var wasOpen = !!document.querySelector('cart-drawer.active');

    var res = await fetch('/?section_id=cart-drawer', { credentials: 'same-origin' });
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newCartDrawer = doc.querySelector('cart-drawer');
    var currentCartDrawer = document.querySelector('cart-drawer');

    if (newCartDrawer && currentCartDrawer) {
      currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
      // Constructor on the fresh element re-binds overlay, keyup, and cart icon.
      // Re-add active + overflow-hidden directly (not via open()) to avoid
      // replaying the slide-in animation while the drawer is already visible.
      if (wasOpen) {
        var freshDrawer = document.querySelector('cart-drawer');
        if (freshDrawer) freshDrawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }
    }
  }
})();
